/**
 * useIsDesktop Hook
 *
 * Detects whether the viewport is desktop-sized (768px+, md breakpoint).
 * Listens for resize events and updates state accordingly.
 *
 * @returns boolean - true if viewport width >= 768px
 */

import { useState, useEffect } from 'react';

/**
 * Hook to detect desktop viewport
 *
 * Defaults to false to avoid SSR/hydration issues, then sets
 * the correct value on mount via useEffect.
 */
export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState<boolean>(false);

  useEffect(() => {
    const checkIsDesktop = () => setIsDesktop(window.innerWidth >= 768);

    // Set initial value
    checkIsDesktop();

    // Listen for resize events
    window.addEventListener('resize', checkIsDesktop);
    return () => window.removeEventListener('resize', checkIsDesktop);
  }, []);

  return isDesktop;
}
